import {
  Filters, ApiPagination, BaseResponse, RequestPagination,
} from '@/types';
import { Products } from '@/modules/products/types';
import { GettingFile } from '@/enums';

export namespace CommercialOffers {
  import ProductPrices = Products.ProductPrices;

  export enum Pages {
    COMMERCIAL_OFFERS = 'commercial_offers',
    NEW_OFFER = 'new_offer',
    OFFER_DETAIL = 'commercial_offer',
    NEW_OFFER_TEMPLATE = 'new_offer_template',
    OFFER_TEMPLATE = 'offer_template',
    EDIT_OFFER_TEMPLATE = 'edit_offer_template',
    EDIT_OFFER = 'edit_offer',

    COMMERCIAL_OFFERS_SLUG = 'commercial_proposal',
  }

  export interface CatalogProduct {
    [key: string]: unknown,
    id: number,
    product_code: string,
    nomenclature: string,
    prices: ProductPrices,
    image_id: string
  }

  export interface CatalogProductResponse extends ApiPagination {
    data: {
      items: CatalogProduct[],
      filters: {
        categories: Products.CategoryFilterItem[],
        software_types: Products.CatalogFilterItem[],
        equipment_models: Products.EquipmentModelFilterItem[]
      }
    }
  }

  export type CatalogProductRequestFilters = {
    [key: string]: unknown,
    search: string,
    categories: number[];
    software_type: number | null;
    equipment_models: number[],
  }

  export type CatalogProductRequest = {
    filters: CatalogProductRequestFilters,
    filters_exist: boolean,
    pagination: RequestPagination,
  }
}

export interface Organization {
  id: number;
  name_organization?: string;
}

export interface OrganizationForFilters {
  id: number;
  name_organization: string;
}

export interface LogoFile {
  [key: string]: unknown;
  id: number;
  temp_id?: number;
  file?: File | null;
  title: string;
  is_active?: boolean;
  original_name?: string;
  is_new_file?: boolean;
}

export interface NewCommercialOfferTemplate {
  [key: string]: unknown;
  title: string;
  company_name: string;
  company_phone: string;
  company_email: string;
  company_url: string;
  company_address: string;
  company_description: string;
  organizations: Organization[];
  files: LogoFile[];
}

export interface CommercialOfferTemplate {
  id: number;
  title: string;
  created_at: string;
  organizations: string;
}

export interface CommercialOffer {
  id: number;
  number: string;
  created_at: string;
  client_name: string;
}

export interface OfferTemplatesFilters extends Filters {
  [key: string]: unknown,
  search: string,
  dates : string[],
  organizations: string[],
}

export interface CommercialOfferFilters extends Filters {
  [key: string]: unknown,
  search: string,
  dates : string[],
  clients: string[],
}

export interface Staff {
  [key: string]: unknown,
  id?: number
  user_id?: number
  full_name: string
  phone: string
  email: string
  job_title: string
  url?: string
  image?: File | null
  image_path?: string
  image_original_name?: string
  new_staff?: boolean
  local_id: number
}

export interface Product {
  [key: string]: unknown,
  id?: number,
  product_id: number,
  is_partner_product: boolean,
  price: number,
  small_wholesale_price: number,
  discount: number,
  quantity: number,
  product_code?: string | number,
  description?: string,
  amount?: number | null,
  amount_with_discount: number | null,
  client_price: string | number,
  nomenclature: string,
  file?: File | null,
  image_id: number | null,
  image_slug: GettingFile.Slugs | null,
}

export interface NewCommercialOffer {
  [key: string]: unknown,
  client_id: number,
  client_name: string,
  client_contact_full_name: string,
  client_contact_phone: string,
  client_contact_email: string,
  created_at?: string,
  products_count?: number,
  amount_with_discount?: number,
  products: Product[],
  users: Staff[],
  is_hide_discount: boolean,
  is_hide_photo_description: boolean,
  has_template: boolean,
  id: number,
}

export interface NewCommercialOfferResponse {
  data: NewCommercialOffer,
}

export interface ResponseTemplateId extends BaseResponse, ApiPagination {
  data: {
    commercial_proposal_template_id?: number;
  };
}

export interface ResponseOfferId extends BaseResponse, ApiPagination {
  data: {
    commercial_proposal_id?: number;
    commercial_proposal_number?: string;
  };
}
